import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';

@Injectable()
export class DeletePartnerNotificationEmailService {

  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public partnerNotificationEmailDelete(id: string): Observable<any> {
    const url = `${this.configService.config.rest.apiV2Url}/partner-notification-emails/${id}`;

    return this.client.delete<any>(url)
    .pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}